export default __webpack_public_path__ + "static/media/profile-video-01.f83c2b5e.jpg";